import apiClient from './apiClient.js';

const userService = {
    getAllUsers(){
       return apiClient.get('/usuarios/'); 
    },
    deleteUser(id){
        return apiClient.delete(`/usuarios/${id}/`);
    },
    createUser(userData) {
        return apiClient.post('/usuarios/', userData);
    },
    createUserInstaller(userData){
        return apiClient.post('/usuarios/', userData);
    },
    getUsersByRol(id_rol){
        return apiClient.get(`/usuarios/?id_rol=${id_rol}`);
    },
    updateUser(id, userData){
        return apiClient.patch(`/usuarios/${id}/`, userData);
    }, 
    changePassword(userId,passwordData){      
        return apiClient.post(`/usuarios/${userId}/set_password/`, passwordData); 
    },
    getUserByID(id){
        return apiClient.get(`/usuarios/${id}/`);        
    },
    requestPasswordReset(email) {
        return apiClient.post('/password-reset/', { email: email });
    },
    confirmPasswordReset(uid, token, newPassword) {
        return apiClient.post('/password-reset-confirm/', {
            uidb64: uid,   
            token: token,    
            password: newPassword 
        });
    }
}

export default userService;